import { Card, CardContent, CardMedia, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import React from 'react';
import img9 from '../images/img9.jpeg';
import img10 from '../images/img10.jpeg';

const useStyle = makeStyles(theme => ({
    card: {
        borderRadius: 4,
        width: '100%',
        height: '100%'
    },
    img: {
        height: 0,
        paddingTop: '56.25%', // 16:9
        objectFit: 'contain'
    }
}))

export default function Feeds(props) {

    const imgArr = [img9, img10];
    const textArr = [
        '黃金金的蟹爪菊有爪銀的意思, 所以是新年必備年花之一。菊—耐寒是冬季名花之一，通常可插放兩星期之久。',
        '菊花種植過程頗長，暑假後就下種，準備新年前收割，而種植工序繁複，每枝菊花都係農夫心血結晶']
    const classes = useStyle();

    return (
        <>
            <Grid item xs={12}>
                <div className='p-1'>
                    <Typography color='primary' variant='h6'>本店新年期間專營合時年花。</Typography>
                    <Typography color='primary' variant='h6'>擁有逾五十年經驗，由上一代經營至今，亦提供本地栽種的百合。悉心栽培，本著「為顧客開心過新年」為宗旨，為每位顧客提供優質服務。</Typography>
                    <Typography color='primary' variant='h6'>本店平日亦有時令瓜菜出售。</Typography>
                    <br />
                    <Typography color='primary' variant='h6'>在農曆新年前，批發各種本地栽種的百合花以及本地蟹爪菊。</Typography>
                    <Typography color='primary' variant='h6'>歡迎查詢​。</Typography>
                    <br />
                    <Typography color='primary' variant='h6'>備有蟹爪菊及多個百合品種年花。不論是大家庭，小家庭或是辦公室，也可充滿濃厚的節日氣氛。</Typography>
                    <Typography color='primary' variant='h6'>歡迎查詢報價</Typography>
                </div>
            </Grid>
            {imgArr.map((image, index) => (
                <Grid item sm={6} xs={12} className='p-2' key={index}>
                    <Card className={classes.card}>
                        <CardMedia
                            className={classes.img}
                            image={image}
                            title="map"
                        />
                        <CardContent>
                            <Typography variant="body2" color="primary" component="p" className={`py-2 ${classes.link}`}>{textArr[index]}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </>
    )
}